import axios from "axios";
import {
  DEFAULT_COMMODITY,
  DEFAULT_CURRENCY,
} from "@/components/overview/constants/newsCategories";
/**
 * Fetches news articles filtered by category tags.
 * @param {object} _this - Vue component instance.
 * @param {object} options
 * @param {string} options.fieldName - Field where the fetched articles will be stored.
 * @param {string} options.fieldShowLoadingName - Field that controls the loading state.
 * @param {string} options.fieldErrorName - Field where error messages will be stored.
 * @param {string} [options.fieldTotalName] - Field where the total count will be stored.
 * @param {string[]} [options.commodities=DEFAULT_COMMODITY] - Category tags to filter news.
 * @param {string[]} [options.currencies=DEFAULT_CURRENCY] - Category tags to filter news.
 * @param {boolean} [options.macro=true]
 * @param {boolean} [options.indexes=true]
 * @param {boolean} [options.interest_rates=true]
 * @param {number} [options.offset=0] - Pagination offset.
 * @param {boolean} [options.append=false] - If true, appends results to existing list instead of replacing.
 */
export function getNews(
  _this,
  {
    fieldName,
    fieldShowLoadingName,
    fieldErrorName,
    fieldTotalName,
    commodities = DEFAULT_COMMODITY,
    currencies = DEFAULT_CURRENCY,
    macro = true,
    indexes = true,
    interest_rates = true,
    offset = 0,
    append = false,
  },
) {
  const commoditiesParam = Array.isArray(commodities)
    ? commodities.join(",")
    : commodities;
  const currenciesParam = Array.isArray(currencies)
    ? currencies.join(",")
    : currencies;
  _this[fieldShowLoadingName] = true;
  _this[fieldErrorName] = null;
  const params = {
    commodities: commoditiesParam,
    currencies: currenciesParam,
    macro: macro ? "true" : "false",
    indexes: indexes ? "true" : "false",
    interest_rates: interest_rates ? "true" : "false",
    offset,
  };
  const token = localStorage.getItem("token");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  return axios
    .get(process.env.VUE_APP_GATEWAY_URL + "news/", { params, headers })
    .then((response) => {
      if (fieldTotalName) {
        _this[fieldTotalName] = response.data.total || 0;
      }
      const data = response.data.data;
      let newArticles;
      if (data && Array.isArray(data.articles)) {
        newArticles = data.articles;
      } else if (Array.isArray(data)) {
        newArticles = data;
      } else {
        newArticles = [];
      }
      if (append) {
        _this[fieldName] = [...(_this[fieldName] || []), ...newArticles];
      } else {
        _this[fieldName] = newArticles;
      }
    })
    .catch((error) => {
      console.error("Error fetching news:", error);
      if (!append) _this[fieldName] = [];
      _this[fieldErrorName] = "Could not load news. Please try again later.";
    })
    .finally(() => {
      _this[fieldShowLoadingName] = false;
    });
}
